export const TOKEN_URLS = {
	__STASH_ENV__: import.meta.env.VITE_STASH_TOKEN_URL || 'https://api-edge.stash.com/stash-auth',
	edge: 'https://api-edge.stash.com/stash-auth',
	staging: 'https://api-staging.stash.com/stash-auth',
	production: 'https://api.stash.com/stash-auth',
} as const;

// Base URLs for LOGIN routes (authorize, token, etc.)
export const BASE_LOGIN_URLS = {
	__STASH_ENV__: import.meta.env.VITE_BASE_LOGIN_URL,
	edge: 'https://login-edge.stash.com',
	staging: 'https://login-staging.stash.com',
	production: 'https://login.stash.com',
};

export const BASE_SIGNUP_URLS = {
	__STASH_ENV__: import.meta.env.VITE_STASH_BASE_SIGNUP_URL,
	edge: 'https://signup-edge.stash.com',
	staging: 'https://signup-staging.stash.com',
	production: 'https://signup.stash.com',
};

export const CLIENT_IDS = {
	__STASH_ENV__: import.meta.env.VITE_STASH_CLIENT_ID,
	edge: 'f29b429f-5483-42e5-8ba6-4aeb02d5d3a9',
	staging: 'e9c5b819-702a-4617-ac77-4c82723df5b7',
	production: '92652692-61cc-48f6-9d41-3031f3031edc',
};

export const REDIRECT_URLS = {
	__STASH_ENV__: 'https://app-local.stash.com:9009/authorize',
	edge: 'https://app-edge.stash.com/authorize',
	staging: 'https://app-staging.stash.com/authorize',
	production: 'https://app.stash.com/authorize',
} as const;

export const SUPPORTED_PRODUCTS = {
	purchase: 'pur',
} as const;
